<template>
  <v-dialog v-model="displaySuccessDialog" persistent max-width="1200" data-qa="addpaymentmandate-dialog-m34hv">
    <dob-snackbar v-if="snackbar.visible"
      :config="{ snackbar }"
    />
    <v-layout wrap data-qa="addpaymentmandate-layout-d21gel">
      <v-flex class="account-mandates--overlayCardFlex" data-qa="addpaymentmandate-flex-kk8b8">
        <v-card data-qa="addpaymentmandate-card-mnsuh">
          <v-toolbar :color="secondaryColor" class="subtitle-1 white--text" max-height="60px" data-qa="addpaymentmandate-toolbar-2km399">
            <v-card-text data-qa="addpaymentmandate-card-text-hkxbi7">
              <font class="subtitle-1 font-weight-bold white--text">{{ !config.mandatesInfo.editMode ? $t("accountMandates.label.addMandate") : $t("accountMandates.label.amendMandate") }}</font>
            </v-card-text>
            <v-btn @click="closePage" icon data-qa="addpaymentmandate-btn-ptji5v">
              <v-icon color="white" class="material-symbols-outlined" data-qa="addpaymentmandate-icon-mzcgcon">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-flex style="margin: 10px;" data-qa="addpaymentmandate-flex-8xftz">
            <span data-qa="addpaymentmandate-span-lok2ug">
              <font :color="darkColor" class="text-h6 font-weight-bold">{{ $t("accountMandates.label.accountMandateDetails") }} </font>
            </span>
          </v-flex>

          <v-row no-gutters data-qa="addpaymentmandate-row-aacfji">
            <div style="margin: 0 10px 0 10px" data-qa="addpaymentmandate-div-y8kcp4">
              <v-avatar :tile="false" size="48" :color="secondaryColor" data-qa="addpaymentmandate-avatar-232fdj">
                <v-icon color="white" x-large data-qa="addpaymentmandate-icon-wm4v79">mdi-account</v-icon>
              </v-avatar>
            </div>
            <div data-qa="addpaymentmandate-div-sixu98">
              <font class="subheading font-weight-regular">{{ $t("accountMandates.label.accountNumber") }}</font><br data-qa="addpaymentmandate-br-yqsdn">
              <font class="caption font-weight-bold">{{ this.config.mandatesInfo.account.text }}</font>
            </div>
          </v-row>
          <v-flex data-qa="addpaymentmandate-flex-wwxsxj">
            <v-card data-qa="addpaymentmandate-card-owwh1d">
              <v-container data-qa="addpaymentmandate-container-m08vh">
                <v-layout data-qa="addpaymentmandate-layout-tzjern">
                  <v-flex xs12 sm12 md4 lg3 x3 data-qa="addpaymentmandate-flex-wcavcx">
                    <v-autocomplete v-model="paymentInitiator" :items="paymentInitiatorList"
                      :color="primaryColor" append-icon="mdi-chevron-down" filled background-color="#f0eff7"
                      :label="$t('accountMandates.label.paymentInitiator')" class="pt-4 pl-2" :rules="[rules.requiredRule]"
                      :item-text="item => `${item.text} - ${item.type}`"
                      :disabled="isReadOnly" @change="handlePaymentInitiatorChange" attach data-qa="addpaymentmandate-autocomplete-qwnt7kp">
                      <template v-slot:item="{ item }">
                        <div data-qa="addpaymentmandate-div-em4rbv">
                          {{ item.text }}
                          <br data-qa="addpaymentmandate-br-8erwd">
                          <font size="2">{{ item.type }}</font>
                        </div>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg3 xl3 data-qa="addpaymentmandate-flex-6um7hd">
                    <v-autocomplete data-qa="accountType" v-model="paymentType" :items="paymentTypeList"
                      :color="primaryColor" append-icon="mdi-chevron-down" filled background-color="#f0eff7"
                      :label="$t('accountMandates.label.paymentType')" class="pt-4 pl-2" :rules="[rules.requiredRule]"
                      :disabled="isReadOnly" attach>
                    </v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg3 xl3 data-qa="addpaymentmandate-flex-w26frl">
                    <v-text-field filled background-color="#f0eff7" :label="$t('accountMandates.label.minimumAmount')"
                      :prefix="$formatter.currency.getCurrencySymbol(config.mandatesInfo.account.currency)" class="pt-4 pl-2" type="number"
                      v-model="minAmount" ref="minRef" @input="validateMaxAmount"
                      :rules="[
                        rules.requiredAmountRule,
                        rules.invalidAmount,
                        rules.greaterThanZero,
                        rules.minValue
                      ]" data-qa="addpaymentmandate-text-field-4n3luj">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md4 lg3 xl3 data-qa="addpaymentmandate-flex-q5i9d9">
                    <v-text-field filled background-color="#f0eff7" :label="$t('accountMandates.label.maximumAmount')"
                      :prefix="$formatter.currency.getCurrencySymbol(config.mandatesInfo.account.currency)" type="number" class="pt-4 pl-2"
                      v-model="maxAmount" ref="maxRef" @input="validateMinAmount"
                      :rules="[
                        rules.requiredAmountRule,
                        rules.invalidAmount,
                        rules.greaterThanZero,
                        rules.maxValue
                      ]" data-qa="addpaymentmandate-text-field-e3qzp">
                    </v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout data-qa="addpaymentmandate-layout-3psuq6">
                  <v-toolbar :color="secondaryColor" class="subtitle-1 white--text" max-height="80px" data-qa="addpaymentmandate-toolbar-5glflq">
                    <v-card-text data-qa="addpaymentmandate-card-text-9lftqh">
                      <v-icon color="white" large style="margin-right: 10px;" data-qa="addpaymentmandate-icon-0c665j">mdi-account-group</v-icon>
                      <font class="subtitle-1 font-weight-bold white--text">{{ $t('accountMandates.label.chainOfApproval') }}
                      </font>
                    </v-card-text>
                  </v-toolbar>
                </v-layout>

                <v-card height="500px" style="overflow-y: scroll;" data-qa="addpaymentmandate-card-1xiuf">
                  <div v-if="!this.addingApprovers && this.approvers.length <= 0"
                    class="white d-flex flex-column justify-center align-center" data-qa="addpaymentmandate-div-w4mp4r">
                    <v-card flat tile class="d-flex flex-column justify-center align-center" style="margin: 15vh;" data-qa="addpaymentmandate-card-au36">
                      <v-avatar :tile="false" size="48" data-qa="addpaymentmandate-avatar-t4z3nc">
                        <v-icon color="gray" x-large data-qa="addpaymentmandate-icon-4tapl">mdi-account-supervisor-circle</v-icon>
                      </v-avatar>
                      <h3 style="text-align: center;" data-qa="addpaymentmandate-h3-34mzxk">{{$t('accountMandates.label.noApproversAdded')}}</h3>
                      <div style="text-align: center; max-width: 400px; opacity: 0.5; padding-bottom: 20px;" data-qa="addpaymentmandate-div-kj4oaj">{{$t('accountMandates.info.noApproverInfo')}}</div>
                      <v-btn icon @click="addNewApprovers()"
                        v-if="paymentInitiator && paymentInitiatorList.length > 1" data-qa="addpaymentmandate-btn-q8ut1m">
                        <v-icon :color="primaryColor" size="50px" class="material-symbols-outlined" data-qa="addpaymentmandate-icon-8niyl">add_circle</v-icon>
                      </v-btn>
                    </v-card>
                  </div>

                  <div v-if="this.addingApprovers || this.approvers.length > 0" style="width: 100%; margin: auto;" data-qa="addpaymentmandate-div-5u0pm">
                    <div style="padding-top: 10px; margin-left: 10px ;" data-qa="addpaymentmandate-div-dt1b9">
                      <font class="subheading font-weight-regular">{{ getApproversCount }} {{$t('accountMandates.label.approvers')}}</font><br data-qa="addpaymentmandate-br-pht28">
                    </div>

                    <div v-for="(item, index) in this.approvers" :key="index" style="margin-left: 10px" :data-qa="`addpaymentmandate-div-9oops-${index}`">
                      <v-toolbar max-height="50px" style="background-color: #e2e0e9; color: transparent;" :data-qa="`addpaymentmandate-toolbar-cuc5e-${index}`">
                        <v-icon :color="secondaryColor" medium style="margin-right: 10px; padding-bottom: 10px;" :data-qa="`addpaymentmandate-icon-hi2ym-${index}`">mdi-account-supervisor-circle-outline</v-icon>
                        <font class="subtitle-1 font-weight-bold black--text" style="padding-bottom: 10px;">{{$t('accountMandates.label.approver')}} {{
                          index + 1 }}</font>
                      </v-toolbar>

                      <div class="d-flex flex-row align-left" :data-qa="`addpaymentmandate-div-04wpz-${index}`">
                        <v-btn-toggle v-if="index !== 0" style="padding: 20px; background-color: transparent"
                          v-model="selectedCondition[index]" @change="handleToggleChange(index)" :data-qa="`addpaymentmandate-btn-toggle-r5s7v-${index}`">
                          <v-btn small :data-qa="`addpaymentmandate-btn-iefn2g-${index}`">{{$t('accountMandates.button.and')}} </v-btn>
                          <v-btn small :data-qa="`addpaymentmandate-btn-cdshr-${index}`">{{$t('accountMandates.button.or')}} </v-btn>
                        </v-btn-toggle>

                        <v-select variant="underlined" style="max-width: 400px;" :items="filterInitiatorList"
                          v-model="selectedApprover[index]" :error-messages="errorMessages[index]"
                          :item-text="item => `${item.text} - ${item.type}`"
                          @input="handleInput(index)" attach :data-qa="`addpaymentmandate-select-si3mhp-${index}`">
                          <template v-slot:item="{ item }">
                            <div :data-qa="`addpaymentmandate-div-vuk7fc-${index}`">
                              {{ item.text }}
                              <br :data-qa="`addpaymentmandate-br-q0zp6-${index}`">
                              <font size="2">{{ item.type }}</font>
                            </div>
                          </template>
                        </v-select>
                        <!-- Add button only shows on last approver and max approvers should not be greater than 9 -->
                        <v-btn icon @click="addNewApprovers(index)"
                          v-if="index === Object.keys(approvers).length - 1 && index < 8"
                          style="padding-top: 20px;" :data-qa="`addpaymentmandate-btn-c7b98k-${index}`">
                          <v-icon :color="secondaryColor" medium class="material-symbols-outlined" :data-qa="`addpaymentmandate-icon-r9srw-${index}`">
                            add_circle</v-icon>
                        </v-btn>
                        <v-btn @click="removeApprover(index)" icon style="padding-top: 20px;" :data-qa="`addpaymentmandate-btn-ham85-${index}`">
                          <v-icon :color="secondaryColor" medium class="material-symbols-outlined" :data-qa="`addpaymentmandate-icon-ex4po-${index}`">
                            delete</v-icon>
                        </v-btn>
                      </div>
                    </div>
                  </div>

                </v-card>

                <v-flex sm12 xs12 md12 lg12 xl12 class="text-right" data-qa="addpaymentmandate-flex-ig0bg5">
                  <v-btn
                    @click="onSave"
                    :color="primaryColor"
                    class="mt-2 text-capitalize font-weight-bold py-2 px-4"
                    :disabled="!isButtonDisabled"
                    :dark="!!isButtonDisabled"
                     data-qa="addpaymentmandate-btn-sikif7">
                    {{ $t("accountMandates.button.onSave") }}
                  </v-btn>
                </v-flex>
              </v-container>
            </v-card>
          </v-flex>
        </v-card>
      </v-flex>
    </v-layout>

    <Modal
      v-if="showPaymentMandateWarning"
      :config="modalWarningConfig"
      @btn2Action="continueAction"
      @btn1Action="cancelAction">
    </Modal>

    <Modal
      v-if="otpPaymentConfig.enabled"
        :config="otpPaymentConfig"
        @cancel="onOtpModalClose"
      >
      <span slot="modalContent" data-qa="addpaymentmandate-span-u4tetl">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>

    <AddPaymentDialog
      v-show="paymentDialog.showConfimModal"
      :config="paymentDialog"
      @closePaymentDialog="onDialogClose"
    />
  </v-dialog>
</template>

<script>
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import event from '@/util/event'
import store from '@/core/store'

export default {
  name: 'AddPaymentMandate',
  components: {
    OtpInput,
    'dob-snackbar': () => import('@/components/DOB-Snackbar/DobSnackbar.vue'),
    Modal: () => import('@/components/common/Modal.vue'),
    AddPaymentDialog: () => import('@/views/mandates/AddPaymentDialog.vue')
  },
  props: {
    config: Object
  },
  data () {
    return {
      paymentInitiatorList: [],
      paymentTypeList: this.$appSettings.defaultConfigurations.accountMandatePaymentTypeList,
      codeToRemoveMap: this.$appSettings.defaultConfigurations.codeRemoveOnSelectedCurrency,
      codeRemoveOnDefault: this.$appSettings.defaultConfigurations.codeRemoveOnDefault,
      accountMandate: '',
      paymentInitiator: '',
      paymentType: '',
      minAmount: ' ',
      maxAmount: ' ',
      addingApprovers: false,
      approvers: [],
      condition: [],
      selectedApprover: [],
      selectedCondition: [],
      errorMessages: [],
      mandateErrMsg: [],
      mandateError: false,
      mandateStatus: '',
      existingMandates: [],
      mandatesDetails: [],
      originalValues: {},
      showPaymentMandateWarning: false,
      approverChanged: false,
      snackbar: {
        icon: '',
        title: '',
        mode: 'multi-line',
        timeout: 4000,
        text: '',
        visible: false,
        color: '',
        top: true,
        right: true,
        multiLine: true
      },
      showOTPScreen: false,
      otpPaymentConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      modalWarningConfig: {
        enabled: false,
        title: this.$t('accountMandates.label.unsaveChanges'),
        subtitle: this.$t('accountMandates.warning.warnUnsavedPayMandate'),
        persistent: true,
        btn1Label: this.$t('accountMandates.button.no'),
        btn2Label: this.$t('accountMandates.button.yes'),
        width: 500
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      enableOTPForAccountMandate: this.$appSettings.defaultConfigurations.enableOTPForAccountMandate,
      paymentDialog: {
        showConfimModal: false
      },
      mandates: [],
      isReadOnly: false,
      displaySuccessDialog: true,
      defaultCurrency: this.$appSettings.defaultConfigurations.currencyFormat.currency,
      rules: {
        requiredRule: (v) => Boolean(v) || this.$t('errors.common.requiredField'),
        requiredAmountRule: (v) => v.toString().length || this.$t('errors.common.amountRequired'),
        minValue: (v) => v < parseFloat(this.maxAmount) || this.$t('accountMandates.errorMsg.minAmountError'),
        maxValue: (v) => v > parseFloat(this.minAmount) || this.$t('accountMandates.errorMsg.maxAmountError'),
        invalidAmount: (v) => {
          let pattern = /^\d*(\.\d{1,2})?$/
          const partyPreferredLocale = store.getters['profileStore/profileData'].preferredLocale

          if (partyPreferredLocale === 'de-DE') {
            pattern = /^\d*(,\d{1,2})?$/
          }
          return pattern.test(v) || this.$t('errors.common.invalidFormat')
        },
        greaterThanZero: (v) => v > 0 || this.$t('errors.common.minAmountError')
      }
    }
  },
  created () {
    this.mandates = this.config.mandatesInfo.mandateDetails
    const codeToRemove = this.codeToRemoveMap[this.config.mandatesInfo.account.currency] || this.codeRemoveOnDefault
    this.paymentTypeList = this.paymentTypeList.filter(item => !codeToRemove.includes(item.value))
    this.paymentInitiatorList = this.config.mandatesInfo.initiatorList.sort((a, b) => a.text.localeCompare(b.text))
    // If view/update mode
    if (this.config.mandatesInfo.approvers) {
      this.config.mandatesInfo.approvers.forEach(app => {
        if (app.approver && !this.paymentInitiatorList.some(item => item.value === app.approver)) {
          app.approver = undefined
        }
      })
    }

    if (this.config && (this.config.mandatesInfo.editMode || this.config.mandatesInfo.copyMode)) {
      this.isReadOnly = this.config.mandatesInfo.editMode
      this.paymentInitiator = this.config.mandatesInfo.initiator
      this.minAmount = this.config.mandatesInfo.minAmount
      this.maxAmount = this.config.mandatesInfo.maxAmount
      this.paymentType = this.config.mandatesInfo.transactionCode
      this.approvers = this.config.mandatesInfo.approvers.filter(item => item.approver !== undefined && item.approver !== null)

      this.approvers.map((item, index) => {
        this.selectedApprover[index] = item.approver
        this.selectedCondition[index + 1] = item.condition
      })
    }

    this.originalValues = {
      paymentInitiator: this.paymentInitiator,
      minAmount: this.minAmount,
      maxAmount: this.maxAmount,
      paymentType: this.paymentType,
      approvers: [...this.approvers]
    }

    event.$on('verifyOTP', args => {
      this.otpPaymentConfig.enabled = true
    })
    event.$on('IS_OTP_VALID', (val) => {
      if (val && this.otpPaymentConfig.enabled) {
        this.otpPaymentConfig.enabled = false
        this.handlePaymentMandateSave()
      }
    })
  },
  computed: {
    isButtonDisabled () {
      return (
        this.paymentInitiator && this.paymentType && this.minAmount && this.maxAmount && (this.paymentInitiator !== this.originalValues.paymentInitiator ||
        this.minAmount !== this.originalValues.minAmount ||
        this.maxAmount !== this.originalValues.maxAmount ||
        this.paymentType !== this.originalValues.paymentType ||
        this.approverChanged ||
        !arraysAreEqual(this.approvers, this.originalValues.approvers))
      )
      function arraysAreEqual (arr1, arr2) {
        return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index])
      }
    },
    filterInitiatorList () {
      return this.paymentInitiatorList.filter(
        item => item.value !== this.paymentInitiator
      )
    },
    getApproversCount () {
      if (this.approvers.length === 0) { this.addingApprovers = false }
      return this.approvers.filter(approver => approver.approver && approver.approver.trim() !== '').length
    },
    buttonIcon () {
      return this.config.mandatesInfo.editMode ? 'mdi-pencil' : 'mdi-plus'
    }
  },
  methods: {
    addNewApprovers (index) {
      this.addingApprovers = true
      this.approvers.push({ approver: undefined, condition: 0 })
      this.selectedCondition[index + 1] = 0
    },
    removeApprover (index) {
      this.approvers.splice(index, 1)
      this.selectedApprover.splice(index, 1)
      this.selectedCondition.splice(index, 1)
      this.errorMessages = []
      if (this.approvers.length === 0) { this.addingApprovers = false }
      this.findDuplicateApprovers()
    },
    async handlePaymentMandateSave () {
      const mandateData = {
        initiator: this.paymentInitiator,
        transactionCode: this.paymentType,
        amountRangeFrom: this.minAmount,
        amountRangeTo: this.maxAmount,
        detailId: this.mandateStatus === 'new' ? null : this.config.mandatesInfo.detailId,
        status: this.mandateStatus
      }
      for (let i = 0; i < 9; i++) {
        const condition = this.approvers[i + 1] ? (this.approvers[i + 1].condition === 0 ? 'AND' : 'OR') : null
        mandateData[`authorizer${i + 1}`] = this.approvers[i] ? this.approvers[i].approver : null
        mandateData[`condition${i + 1}`] = condition
      }
      const mandate = {
        transactionChannelId: this.config.mandatesInfo.transactionChannelId,
        serviceMode: this.config.mandatesInfo.serviceMode,
        accountId: this.config.mandatesInfo.account.value,
        mandateRequiredFlag: this.config.mandatesInfo.mandateRequiredFlag,
        authorizerRequiredFlag: this.config.mandatesInfo.authorizerRequiredFlag,
        mandateDetails: [...this.mandatesDetails, mandateData]
      }
      // call POST API if add
      if (this.mandateStatus === 'new') {
        await commonService.saveMandates(mandate.accountId, mandate.serviceMode, mandate).then(
          resp => { this.processResponse(resp) }
        )
      } else if (this.mandateStatus === 'edit') {
        await commonService.amendMandates(mandate).then(
          resp => { this.processResponse(resp) }
        )
      }
    },
    processResponse (resp) {
      this.paymentDialog = {
        showConfimModal: false
      }
      if (!resp.causes) {
        this.paymentDialog.showConfimModal = true
        this.paymentDialog.action = 'success'
      } else {
        this.paymentDialog.action = 'fail'
        this.paymentDialog.showConfimModal = true
        const uniqueCode = [...new Map(resp.causes.map((item) => [item.code, item])).values()]
        this.paymentDialog.causes = uniqueCode
      }
    },
    addMandate () {
      this.existingMandates = this.mandates !== undefined ? this.mandates.filter(
        item => item.initiator === this.paymentInitiator && item.transactionCode === this.paymentType
      ) : []
      this.validateMandate()
      if (!this.mandateError && this.enableOTPForAccountMandate) {
        this.showOTPScreen = true
        this.otpPaymentConfig.enabled = true
        this.mandateStatus = 'new'
        this.sendOTP()
      }
    },
    updateMandate () {
      this.existingMandates = this.mandates.filter(
        item => item.initiator === this.paymentInitiator && item.transactionCode === this.paymentType
      )
      this.validateMandate()
      if (!this.mandateError && this.enableOTPForAccountMandate) {
        this.showOTPScreen = true
        this.otpPaymentConfig.enabled = true
        this.mandateStatus = 'edit'
        this.sendOTP()
      }
    },
    sendOTP () {
      if (this.enableOTPForAccountMandate && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    },
    onDialogClose () {
      this.$emit('addMandateData')
    },
    handlePaymentInitiatorChange () {
      const selectedApproverIndex = this.approvers.findIndex(
        (approver) => approver.approver === this.paymentInitiator
      )
      if (selectedApproverIndex !== -1) {
        this.approvers.splice(selectedApproverIndex, 1)
        this.selectedApprover.splice(selectedApproverIndex, 1)
        this.selectedCondition.splice(selectedApproverIndex, 1)
      }
    },
    validateMinAmount () {
      this.$refs.minRef.validate()
    },
    validateMaxAmount () {
      this.$refs.maxRef.validate()
    },
    onOtpModalClose () {
      this.showOTPScreen = false
      this.otpPaymentConfig.enabled = false
      this.otpPaymentConfig.enableSave = true
    },
    validateMandate () {
      const newStart = parseFloat(this.minAmount)
      const newEnd = parseFloat(this.maxAmount)
      const mandateErrMsg = []
      this.mandateError = false
      // Validates amount range overlapping and duplicate mandates.
      if (parseFloat(this.minAmount) <= 0 || parseFloat(this.maxAmount) <= 0) {
        mandateErrMsg.push(this.$t('accountMandates.errorMsg.zeroAmountError'))
      } else if (parseFloat(this.minAmount) >= parseFloat(this.maxAmount)) {
        mandateErrMsg.push(this.$t('accountMandates.errorMsg.minAmountError'))
      } else if (parseFloat(this.maxAmount) <= parseFloat(this.minAmount)) {
        mandateErrMsg.push(this.$t('accountMandates.errorMsg.maxAmountError'))
      }

      if (this.existingMandates.length > 0) {
        for (const item of this.existingMandates) {
          if (newStart === parseFloat(item.amountRangeFrom) && newEnd === parseFloat(item.amountRangeTo)) {
            mandateErrMsg.push(this.$t('accountMandates.errorMsg.payMandateDupErr'))
            break
          } else if (!(newEnd < parseFloat(item.amountRangeFrom) || newStart > parseFloat(item.amountRangeTo))) {
            mandateErrMsg.push(this.$t('accountMandates.errorMsg.payMandateOverLapErr'))
            break
          }
        }
      }
      // Validates approver list
      for (let i = 0; i < this.approvers.length; i++) {
        if (this.approvers[i].approver === undefined && this.selectedApprover[i] === undefined) {
          mandateErrMsg.push(this.$t('accountMandates.errorMsg.approverMissing') + `${i + 1}`)
        }
      }

      if (this.errorMessages.some(arr => arr.length > 0)) { mandateErrMsg.push(this.$t('accountMandates.errorMsg.approverDup')) }

      if (mandateErrMsg.length > 0) {
        this.snackbar = {
          title: this.$t('accountMandates.errorMsg.addMandateFailed'),
          text: this.$t('accountMandates.errorMsg.addMandateFailedTxt'),
          reason: mandateErrMsg,
          visible: true,
          color: 'error'
        }
        this.mandateError = true
      }
    },
    closePage () {
      const changesMade = (
        this.paymentInitiator !== this.originalValues.paymentInitiator ||
        this.minAmount !== this.originalValues.minAmount ||
        this.maxAmount !== this.originalValues.maxAmount ||
        this.paymentType !== this.originalValues.paymentType ||
        this.approverChanged ||
        !arraysAreEqual(this.approvers, this.originalValues.approvers)
      )
      function arraysAreEqual (arr1, arr2) {
        return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index])
      }
      if (changesMade) {
        this.showPaymentMandateWarning = this.modalWarningConfig.enabled = true
      } else {
        this.$emit('close')
      }
    },
    cancelAction () {
      this.showPaymentMandateWarning = false
    },
    continueAction () {
      this.showPaymentMandateWarning = false
      this.$emit('close')
    },
    handleInput (index) {
      this.approvers[index].approver = this.selectedApprover[index]
      this.approverChanged = true
      this.findDuplicateApprovers()
    },
    findDuplicateApprovers () {
      const duplicates = this.approvers.reduce((acc, item, index) => {
        const approver = item.approver
        if (approver && approver.trim() !== '') {
          acc[approver] = acc[approver] || []
          acc[approver].push(index)
          this.errorMessages[index] = []
        }
        return acc
      }, {})

      for (const approver in duplicates) {
        if (duplicates[approver].length > 1) {
          duplicates[approver].forEach((item) => {
            this.errorMessages[item] = [this.$t('accountMandates.errorMsg.duplicateItemErr')]
          })
        }
      }
    },
    handleToggleChange (index) {
      this.approvers[index].condition = this.selectedCondition[index]
    },
    onSave () {
      if (this.config.mandatesInfo.editMode) {
        this.updateMandate()
      } else {
        this.addMandate()
      }
    }
  }
}
</script>
